import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import getJsonSummary from '../../../../../services/mini/getJsonSummary';
import * as actions from '../../../../../redux/projects/actions.projects';

class CommandsTestModeBubble extends React.Component {

    showCommands = () => {
        const { showFullCommands, data } = this.props;
        showFullCommands({
            commandInfo: {
                commandData: data?.commands
            },
            openPanel: true
        });
    }

    render() {
        const { data } = this.props;

        return (
            <div className="command" onClick={this.showCommands}>
                {data.commands.map((command) => {
                    return <div key={command.id}>
                        {getJsonSummary(command.data)}
                    </div>;
                })}
            </div>
        );
    }
}


function mapStateToProps() {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showFullCommands: (param) => dispatch(actions.showFullCommands(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommandsTestModeBubble);

